import { Navigate, Outlet } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import NAV from "../utils/nav.const";

const ProtectedRoute = () => {
  const { user, loading } = useUserAuth();

  if (loading) {
    return null;
  }

  return user ? <Outlet /> : <Navigate to={NAV.SIGNIN} />;
};

export default ProtectedRoute;
